<template>
  <div class="animated fadeIn">
    <basic-heading title="Service Question Details">
      <template #right-content>
        <!-- header button toolbar -->
        <header-button-group :button_config="button_config">
        </header-button-group>
      </template>
    </basic-heading>

    <!-- info card -->
    <service-question-card
      :submissionquestion="submissionquestion"
    ></service-question-card>
  </div>
</template>

<script>
import Vue from "vue";
import BasicHeading from "@/components/shared/BasicHeading";
import ServiceQuestionCard from "@/components/lab/servicequestion/ServiceQuestionCard";
import VueNotifications from "vue-notifications";
import { notificationOptions } from "@/shared/toast-notification-options";
import { serviceQuestionNotifications } from "@/shared/notifications";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";

const ServiceQuestionRepository = LabRepositoryFactory.get("serviceQuestion");

Vue.use(VueNotifications, notificationOptions);

export default {
  name: "ServiceQuestionDetail",
  components: {
    BasicHeading,
    ServiceQuestionCard,
    HeaderButtonGroup,
  },
  data() {
    return {
      id: this.$route.params.id || null,
      submissionquestion: {},
    };
  },
  computed: {
    /**
     * Header button configuration
     */
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-list",
            linkto: "/",
            title: "Service question list",
          },
        ],
      };
    },
  },
  mounted() {
    if (this.id) {
      const id = this.id;
      ServiceQuestionRepository.get(id).then((response) => {
        if (response && response.status === 200 && response.data) {
          this.submissionquestion = Object.assign({}, response.data);
        }
      });
    }
  },
};
</script>
